/* eslint-disable */
import Header from "components/Common/Header/Header";
import ProductVariationBody from "components/MarketplaceComponents/ProductComponents/ProductDetails/ProductVariation/ProductVariationBody";
import { useEffect } from "react";

const ProductVariations = () => {
  useEffect(() => {
    document.title = "Marketplace";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="marketplace" />
      <ProductVariationBody />
    </main>
  );
};

export default ProductVariations;
